import { SET_MODEL_CHANGED } from "@/store/shared/mutations"

const CUSTOM_AUDIENCE_APPEND = (state, payload) => {
  state.model.audience.targeting.customAudiences.push(payload)

  SET_MODEL_CHANGED(state, true)
}

const CUSTOM_AUDIENCE_REMOVE = (state, payload) => {
  state.model.audience.targeting.customAudiences.splice(payload, 1)

  SET_MODEL_CHANGED(state, true)
}

const CUSTOM_AUDIENCE_UPDATE = (state, payload) => {
  const { audience, index } = payload

  state.model.audience.targeting.customAudiences.splice(index, 1, audience)

  SET_MODEL_CHANGED(state, true)
}

const EXCLUDED_CUSTOM_AUDIENCE_APPEND = (state, payload) => {
  state.model.audience.targeting.excludedCustomAudiences.push(payload)

  SET_MODEL_CHANGED(state, true)
}

const EXCLUDED_CUSTOM_AUDIENCE_REMOVE = (state, payload) => {
  state.model.audience.targeting.excludedCustomAudiences.splice(payload, 1)

  SET_MODEL_CHANGED(state, true)
}

const EXCLUDED_CUSTOM_AUDIENCE_UPDATE = (state, payload) => {
  const { audience, index } = payload

  state.model.audience.targeting.excludedCustomAudiences.splice(
    index,
    1,
    audience
  )

  SET_MODEL_CHANGED(state, true)
}

export {
  CUSTOM_AUDIENCE_APPEND,
  CUSTOM_AUDIENCE_REMOVE,
  CUSTOM_AUDIENCE_UPDATE,
  EXCLUDED_CUSTOM_AUDIENCE_APPEND,
  EXCLUDED_CUSTOM_AUDIENCE_REMOVE,
  EXCLUDED_CUSTOM_AUDIENCE_UPDATE,
}
